const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const getDomains = () => async () => {
        try {
            var response = await axiosCall.get('admin/domains');
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const createDomain = (payload) => async () =>
        axiosCall
            .post('admin/domains', { ...payload })
            .then((res) => res.data)
            .catch((err) => {
                throw err;
            });

    const deletePartnerDomain = (id) => async () =>
        await axiosCall.delete('admin/domains/' + id);

    return {
        createDomain,
        deletePartnerDomain,
        getDomains,
    };
};

export default initActions;
